import React from "react";

interface AgentSchema {
  type: string;
  properties: {
    [key: string]: {
      type: string;
      description: string;
      input_kind: string;
      options?: string[];
      accept?: string[];
      items?: {
        enum?: string[];
      };
    };
  };
  required: string[];
}

interface AgentRelation {
  agent_id: string;
  agent_title: string;
  agent_image: string;
  agent_description: string;
  agent_kind: string;
  agent_schema: AgentSchema;
  child_license: boolean;
}

interface RelationsSectionProps {
  relations?: AgentRelation[];
}

const RelationsSection = ({ relations }: RelationsSectionProps) => {
  if (!relations || relations.length === 0) return null;

  return (
    <div className="mt-10 p-8 rounded-xl border border-slate-200 mx-auto bg-white shadow-sm font-serif-kr">
      <div className="mb-6">
        <h3 className="text-lg md:text-2xl font-semibold text-slate-900 mb-2">연관된 AI 에이전트</h3>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {relations.map((relation) => (
          <div 
            key={relation.agent_id}
            className="p-4 border border-slate-200 rounded-lg hover:border-slate-300 hover:shadow-sm transition-all duration-200 cursor-pointer group"
            onClick={() => {
              window.location.href = `/agent/${relation.agent_id}`;
            }}
          >
            <div className="flex items-center justify-center gap-4">
              <img
                src={relation.agent_image}
                alt={relation.agent_title}
                className="w-[65px] h-[65px] rounded-lg object-cover ring-1 ring-slate-200 flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <h4 className=" font-medium text-slate-900 group-hover:text-slate-700 transition-colors mb-1 truncate">
                  {relation.agent_title}
                </h4>
                <p className="text-[15px] md:text-base text-slate-600 leading-[18px] md:leading-[20px] line-clamp-2">
                  {relation.agent_description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelationsSection; 